import { SVGProps } from 'react';

const Logo = (
  props: SVGProps<SVGSVGElement> & { dark?: boolean | undefined },
) => (
  <svg
    width={88}
    height={35}
    viewBox='0 0 88 35'
    fill={props.dark ? 'white' : '#00ACF0'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M43.4817 25.6457C43.4817 28.7378 41.7818 31.2274 38.0818 31.2274C34.3818 31.2274 32.7578 28.8889 32.7578 25.6457V15.8394H31.1318V25.7202C31.1318 29.7937 33.4248 32.8102 38.0828 32.8102C42.8147 32.8102 45.1827 29.567 45.1827 25.7958V15.9149H43.5567L43.4817 25.6457Z' />
    <path d='M53.9805 15.7637H52.2805L52.2065 32.5089L63.9624 32.5844V31.0731L53.9095 31.0006L53.9805 15.7637Z' />
    <path d='M75.3495 15.388C74.2077 15.3644 73.073 15.5754 72.0147 16.0081C70.9565 16.4409 69.9968 17.0863 69.1942 17.905C68.3917 18.7237 67.763 19.6985 67.3467 20.7701C66.9304 21.8416 66.735 22.9873 66.7726 24.1374C66.7865 25.8525 67.3044 27.5249 68.2609 28.9436C69.2174 30.3623 70.5697 31.4637 72.147 32.1087C73.7243 32.7536 75.4559 32.9133 77.1232 32.5674C78.7905 32.2216 80.3187 31.3858 81.5149 30.1656C82.7111 28.9453 83.5216 27.3953 83.8441 25.7113C84.1667 24.0273 83.9868 22.2847 83.3271 20.7037C82.6675 19.1226 81.5577 17.7739 80.1378 16.8278C78.718 15.8817 77.0518 15.3807 75.3495 15.388V15.388ZM75.2755 31.307C74.3478 31.3238 73.4266 31.148 72.5691 30.7907C71.7117 30.4334 70.9364 29.9022 70.2914 29.2301C69.6464 28.5581 69.1455 27.7595 68.8199 26.8841C68.4943 26.0087 68.3509 25.0751 68.3986 24.1415C68.3764 23.2078 68.5397 22.279 68.879 21.4099C69.2182 20.5407 69.7266 19.7487 70.3742 19.0804C71.0217 18.4121 71.7954 17.881 72.6497 17.5185C73.5039 17.1559 74.4216 16.9691 75.3486 16.9691C76.2755 16.9691 77.1931 17.1559 78.0474 17.5185C78.9017 17.881 79.6754 18.4121 80.3229 19.0804C80.9705 19.7487 81.4788 20.5407 81.8181 21.4099C82.1574 22.279 82.3207 23.2078 82.2985 24.1415C82.3408 25.0858 82.1888 26.0287 81.8519 26.9109C81.515 27.7931 81.0005 28.5955 80.3409 29.2677C79.6813 29.9399 78.8907 30.4672 78.019 30.8167C77.1473 31.1661 76.2132 31.3299 75.2755 31.298V31.307Z' />
    <path d='M4.518 0H4V0.527948H4.518V0Z' />
    <path d='M6.514 0.679199H6V1.20715H6.518L6.514 0.679199Z' />
    <path d='M8.5839 1.5083H8.06592V2.03625H8.5839V1.5083Z' />
    <path d='M10.6547 2.2627H10.1367V2.79064H10.6547V2.2627Z' />
    <path d='M12.7239 3.09229H12.21V3.62023H12.727L12.7239 3.09229Z' />
    <path d='M14.7211 3.771H14.2031V4.29895H14.7211V3.771Z' />
    <path d='M16.643 4.52588H16.126V5.05383H16.643V4.52588Z' />
    <path d='M18.4916 5.12939H17.9736V5.65734H18.4916V5.12939Z' />
    <path d='M20.1928 5.73193H19.6748V6.25988H20.1928V5.73193Z' />
    <path d='M6.66203 1.96045H6.14404V2.48839H6.66203V1.96045Z' />
    <path d='M8.43594 2.56396H7.91895V3.09191H8.43594V2.56396Z' />
    <path d='M10.288 3.16748H9.771V3.69543H10.288V3.16748Z' />
    <path d='M12.1337 3.84668H11.6157V4.37463H12.1337V3.84668Z' />
    <path d='M13.9809 4.52588H13.4639V5.05383H13.9809V4.52588Z' />
    <path d='M15.831 5.12939H15.313V5.65734H15.831V5.12939Z' />
    <path d='M17.6039 5.73193H17.0869V6.25988H17.6039V5.73193Z' />
    <path d='M19.2309 6.33545H18.7139V6.86541H19.2309V6.33545Z' />
    <path d='M20.8578 6.7876H20.3398V7.31554H20.8578V6.7876Z' />
    <path d='M8.65811 3.771H8.14111V4.29895H8.65811V3.771Z' />
    <path d='M10.2109 4.29932H9.69287V4.82726H10.2109V4.29932Z' />
    <path d='M11.8378 4.82812H11.3198V5.35607H11.8378V4.82812Z' />
    <path d='M13.538 5.35596H13.02V5.88391H13.538V5.35596Z' />
    <path d='M15.164 5.88281H14.647V6.41076H15.164V5.88281Z' />
    <path d='M16.8647 6.48633H16.3467V7.01427H16.8647V6.48633Z' />
    <path d='M18.4179 6.93896H17.8999V7.46691H18.4179V6.93896Z' />
    <path d='M19.9731 7.46777H19.4551V7.99572H19.9731V7.46777Z' />
    <path d='M21.4467 7.92041H20.9287V8.44836H21.4467V7.92041Z' />
    <path d='M10.3588 5.50635H9.84082V6.03429H10.3588V5.50635Z' />
    <path d='M11.7621 5.88281H11.2451V6.41076H11.7621V5.88281Z' />
    <path d='M13.2421 6.33545H12.7241V6.86541H13.2421V6.33545Z' />
    <path d='M14.7949 6.7876H14.2769V7.31554H14.7949V6.7876Z' />
    <path d='M16.2739 7.24023H15.7559V7.76818H16.2739V7.24023Z' />
    <path d='M17.7529 7.69336H17.2349V8.22131H17.7529V7.69336Z' />
    <path d='M19.2309 8.146H18.7139V8.67395H19.2309V8.146Z' />
    <path d='M20.7099 8.52393H20.1929V9.05188H20.7099V8.52393Z' />
    <path d='M22.0409 8.90039H21.5229V9.42834H22.0409V8.90039Z' />
    <path d='M11.912 7.08984H11.394V7.61779H11.912V7.08984Z' />
    <path d='M13.1689 7.39209H12.6509V7.92004H13.1689V7.39209Z' />
    <path d='M14.499 7.76904H13.981V8.29699H14.499V7.76904Z' />
    <path d='M15.9037 8.146H15.3857V8.67395H15.9037V8.146Z' />
    <path d='M17.2358 8.52393H16.7178V9.05188H17.2358V8.52393Z' />
    <path d='M18.6401 8.90039H18.1221V9.42834H18.6401V8.90039Z' />
    <path d='M19.9731 9.27734H19.4551V9.80529H19.9731V9.27734Z' />
    <path d='M21.3012 9.57861H20.7842V10.1066H21.3012V9.57861Z' />
    <path d='M22.558 9.95654H22.041V10.4845H22.558V9.95654Z' />
    <path d='M13.2421 8.59912H12.7241V9.12707H13.2421V8.59912Z' />
    <path d='M14.4247 8.8252H13.9067V9.35314H14.4247V8.8252Z' />
    <path d='M15.6088 9.12744H15.0908V9.65539H15.6088V9.12744Z' />
    <path d='M16.8647 9.42871H16.3467V9.95666H16.8647V9.42871Z' />
    <path d='M18.122 9.72998H17.604V10.2599H18.122V9.72998Z' />
    <path d='M19.3788 10.0322H18.8608V10.5602H19.3788V10.0322Z' />
    <path d='M20.6362 10.3345H20.1182V10.8624H20.6362V10.3345Z' />
    <path d='M21.8188 10.6357H21.3008V11.1637H21.8188V10.6357Z' />
    <path d='M23.0019 10.937H22.4839V11.465H23.0019V10.937Z' />
    <path d='M14.352 9.95654H13.834V10.4845H14.352V9.95654Z' />
    <path d='M15.4598 10.1812H14.9468V10.7091H15.4638L15.4598 10.1812Z' />
    <path d='M16.5697 10.4097H16.0518V10.9376H16.5697V10.4097Z' />
    <path d='M17.7529 10.6357H17.2349V11.1637H17.7529V10.6357Z' />
    <path d='M18.9349 10.937H18.4209V11.465H18.9379L18.9349 10.937Z' />
    <path d='M20.0439 11.1636H19.5259V11.6915H20.0439V11.1636Z' />
    <path d='M21.227 11.3892H20.709V11.9171H21.227V11.3892Z' />
    <path d='M22.3368 11.6157H21.8188V12.1437H22.3368V11.6157Z' />
    <path d='M23.4457 11.8428H22.9277V12.3707H23.4457V11.8428Z' />
    <path d='M15.3129 11.2422H14.7949V11.7701H15.3129V11.2422Z' />
    <path d='M16.348 11.3892H15.8311V11.9171H16.348V11.3892Z' />
    <path d='M17.457 11.6157H16.939V12.1437H17.457V11.6157Z' />
    <path d='M18.4916 11.7671H17.9736V12.295H18.4916V11.7671Z' />
    <path d='M19.601 11.9927H19.083V12.5206H19.601V11.9927Z' />
    <path d='M20.6362 12.2192H20.1182V12.7472H20.6362V12.2192Z' />
    <path d='M21.7451 12.3706H21.2271V12.8986H21.7451V12.3706Z' />
    <path d='M22.7797 12.5962H22.2617V13.1231H22.7797V12.5962Z' />
    <path d='M23.8149 12.7471H23.2979V13.275H23.8149V12.7471Z' />
    <path d='M16.1996 12.4463H15.6836V12.9742H16.2016L16.1996 12.4463Z' />
    <path d='M17.1611 12.5205H16.6431V13.0485H17.1611V12.5205Z' />
    <path d='M18.122 12.7471H17.604V13.275H18.122V12.7471Z' />
    <path d='M19.1567 12.8984H18.6387V13.4264H19.1567V12.8984Z' />
    <path d='M20.1176 13.0454H19.6006V13.5734H20.1176V13.0454Z' />
    <path d='M21.1538 13.1997H20.6318V13.7277H21.1498L21.1538 13.1997Z' />
    <path d='M22.183 13.3506H21.665V13.8785H22.183V13.3506Z' />
    <path d='M23.1498 13.501H22.6318V14.0289H23.1488L23.1498 13.501Z' />
    <path d='M24.1107 13.6533H23.5938V14.1843H24.1107V13.6533Z' />
    <path d='M16.8647 13.501H16.3467V14.0289H16.8647V13.501Z' />
    <path d='M17.8256 13.6533H17.3076V14.1843H17.8256V13.6533Z' />
    <path d='M18.7099 13.7275H18.1919V14.2555H18.7099V13.7275Z' />
    <path d='M19.6747 13.8789H19.1577V14.4069H19.6757L19.6747 13.8789Z' />
    <path d='M20.6362 14.0288H20.1182V14.5568H20.6362V14.0288Z' />
    <path d='M21.5971 14.1802H21.0801V14.7081H21.5971V14.1802Z' />
    <path d='M22.558 14.2559H22.041V14.7838H22.558V14.2559Z' />
    <path d='M23.4457 14.4067H22.9277V14.9347H23.4457V14.4067Z' />
    <path d='M24.3329 14.4824H23.8149V15.0104H24.3329V14.4824Z' />
    <path d='M17.457 14.5566H16.939V15.0846H17.457V14.5566Z' />
    <path d='M18.3437 14.6353H17.8257V15.1632H18.3437V14.6353Z' />
    <path d='M19.2309 14.7837H18.7139V15.3116H19.2309V14.7837Z' />
    <path d='M20.1176 14.8594H19.6006V15.3873H20.1176V14.8594Z' />
    <path d='M21.0048 14.9346H20.4878V15.4625H21.0048V14.9346Z' />
    <path d='M21.9657 15.0859H21.4487V15.6139H21.9657V15.0859Z' />
    <path d='M22.8539 15.1655H22.3369V15.6935H22.8539V15.1655Z' />
    <path d='M23.7407 15.2358H23.2227V15.7638H23.7407V15.2358Z' />
    <path d='M24.5546 15.3115H24.0366V15.8395H24.5546V15.3115Z' />
    <path d='M17.973 15.5381H17.4561V16.066H17.973V15.5381Z' />
    <path d='M18.787 15.6138H18.269V16.1417H18.787V15.6138Z' />
    <path d='M19.601 15.6895H19.083V16.2174H19.601V15.6895Z' />
    <path d='M20.4887 15.7637H19.9707V16.2916H20.4887V15.7637Z' />
    <path d='M21.3759 15.8394H20.8579V16.3673H21.3759V15.8394Z' />
    <path d='M22.183 15.915H21.665V16.443H22.183V15.915Z' />
    <path d='M23.0756 15.9907H22.5576V16.5177H23.0756V15.9907Z' />
    <path d='M23.8897 16.0659H23.3687V16.5939H23.8867L23.8897 16.0659Z' />
    <path d='M24.7768 16.1416H24.2588V16.6695H24.7768V16.1416Z' />
    <path d='M18.3437 16.5186H17.8257V17.0475H18.3437V16.5186Z' />
    <path d='M19.1567 16.5186H18.6387V17.0475H19.1567V16.5186Z' />
    <path d='M19.9731 16.5933H19.4551V17.1212H19.9731V16.5933Z' />
    <path d='M20.7836 16.6694H20.2656V17.1974H20.7836V16.6694Z' />
    <path d='M21.5971 16.6694H21.0801V17.1974H21.5971V16.6694Z' />
    <path d='M22.411 16.7451H21.895V17.2731H22.413L22.411 16.7451Z' />
    <path d='M23.2978 16.8208H22.7798V17.3487H23.2978V16.8208Z' />
    <path d='M24.1107 16.8955H23.5938V17.4235H24.1107V16.8955Z' />
    <path d='M24.851 16.8955H24.333V17.4235H24.851V16.8955Z' />
    <path d='M18.6401 17.3486H18.1221V17.8766H18.6401V17.3486Z' />
    <path d='M19.3788 17.4243H18.8608V17.9523H19.3788V17.4243Z' />
    <path d='M20.1928 17.4243H19.6748V17.9523H20.1928V17.4243Z' />
    <path d='M21.0048 17.499H20.4878V18.027H21.0048V17.499Z' />
    <path d='M21.8188 17.499H21.3008V18.027H21.8188V17.499Z' />
    <path d='M22.6327 17.5742H22.1147V18.1072H22.6327V17.5742Z' />
    <path d='M23.4457 17.5742H22.9277V18.1072H23.4457V17.5742Z' />
    <path d='M24.183 17.6499H23.665V18.1779H24.183V17.6499Z' />
    <path d='M24.998 17.6499H24.481V18.1779H24.998V17.6499Z' />
    <path d='M18.8607 18.1777H18.3438V18.7057H18.8607V18.1777Z' />
    <path d='M19.601 18.2534H19.083V18.7814H19.601V18.2534Z' />
    <path d='M20.414 18.2534H19.895V18.7814H20.412L20.414 18.2534Z' />
    <path d='M21.1538 18.2534H20.6318V18.7814H21.1498L21.1538 18.2534Z' />
    <path d='M21.9657 18.3291H21.4487V18.857H21.9657V18.3291Z' />
    <path d='M22.7797 18.3291H22.2617V18.857H22.7797V18.3291Z' />
    <path d='M23.5189 18.4038H23.002V18.9318H23.5189V18.4038Z' />
    <path d='M24.2587 18.4038H23.7407V18.9318H24.2587V18.4038Z' />
    <path d='M25.0727 18.4038H24.5547V18.9318H25.0727V18.4038Z' />
    <path d='M19.0097 19.0068H18.4917V19.5348H19.0097V19.0068Z' />
    <path d='M19.749 19.0068H19.231V19.5348H19.749V19.0068Z' />
    <path d='M20.5619 19.0825H20.0439V19.6105H20.5619V19.0825Z' />
    <path d='M21.3012 19.0825H20.7842V19.6105H21.3012V19.0825Z' />
    <path d='M22.1147 19.0825H21.5967V19.6105H22.1147V19.0825Z' />
    <path d='M22.8539 19.0825H22.3369V19.6105H22.8539V19.0825Z' />
    <path d='M23.5937 19.1592H23.0757V19.6871H23.5937V19.1592Z' />
    <path d='M24.3329 19.1592H23.8149V19.6871H24.3329V19.1592Z' />
    <path d='M25.1459 19.1592H24.6309V19.6871H25.1488L25.1459 19.1592Z' />
    <path d='M19.1567 19.7617H18.6387V20.2897H19.1567V19.7617Z' />
    <path d='M19.8969 19.7617H19.3789V20.2897H19.8969V19.7617Z' />
    <path d='M20.6362 19.832H20.1182V20.36H20.6362V19.832Z' />
    <path d='M21.3759 19.832H20.8579V20.36H21.3759V19.832Z' />
    <path d='M22.183 19.832H21.665V20.36H22.183V19.832Z' />
    <path d='M22.9276 19.832H22.4106V20.36H22.9276V19.832Z' />
    <path d='M23.6669 19.832H23.1489V20.36H23.6669V19.832Z' />
    <path d='M24.406 19.9131H23.894V20.441H24.4111L24.406 19.9131Z' />
    <path d='M25.1459 19.9131H24.6309V20.441H25.1488L25.1459 19.9131Z' />
    <path d='M19.2309 20.5166H18.7139V21.0445H19.2309V20.5166Z' />
    <path d='M19.9731 20.5166H19.4551V21.0445H19.9731V20.5166Z' />
    <path d='M20.7099 20.5918H20.1929V21.1197H20.7099V20.5918Z' />
    <path d='M21.4467 20.5918H20.9287V21.1197H21.4467V20.5918Z' />
    <path d='M22.183 20.5918H21.665V21.1197H22.183V20.5918Z' />
    <path d='M22.9276 20.5918H22.4106V21.1197H22.9276V20.5918Z' />
    <path d='M23.6669 20.5918H23.1489V21.1197H23.6669V20.5918Z' />
    <path d='M24.406 20.5918H23.894V21.1197H24.4111L24.406 20.5918Z' />
    <path d='M25.1459 20.5918H24.6309V21.1197H25.1488L25.1459 20.5918Z' />
    <path d='M19.3051 21.271H18.7871V21.7989H19.3051V21.271Z' />
    <path d='M20.0439 21.271H19.5259V21.7989H20.0439V21.271Z' />
    <path d='M20.7836 21.271H20.2656V21.7989H20.7836V21.271Z' />
    <path d='M21.5229 21.271H21.0049V21.7989H21.5229V21.271Z' />
    <path d='M22.2616 21.271H21.7446V21.7989H22.2616V21.271Z' />
    <path d='M23.0019 21.271H22.4839V21.7989H23.0019V21.271Z' />
    <path d='M23.7407 21.271H23.2227V21.7989H23.7407V21.271Z' />
    <path d='M24.4809 21.3457H23.9629V21.8737H24.4809V21.3457Z' />
    <path d='M25.2196 21.3457H24.7017V21.8737H25.2196V21.3457Z' />
    <path d='M19.3051 22.0249H18.7871V22.5529H19.3051V22.0249Z' />
    <path d='M20.0439 22.0249H19.5259V22.5529H20.0439V22.0249Z' />
    <path d='M20.7836 22.0249H20.2656V22.5529H20.7836V22.0249Z' />
    <path d='M21.5229 22.0249H21.0049V22.5529H21.5229V22.0249Z' />
    <path d='M22.2616 22.0249H21.7446V22.5529H22.2616V22.0249Z' />
    <path d='M23.0019 22.0249H22.4839V22.5529H23.0019V22.0249Z' />
    <path d='M23.7407 22.0249H23.2227V22.5529H23.7407V22.0249Z' />
    <path d='M24.4809 22.0249H23.9629V22.5529H24.4809V22.0249Z' />
    <path d='M25.2196 22.0249H24.7017V22.5529H25.2196V22.0249Z' />
    <path d='M19.3788 22.7036H18.8608V23.2316H19.3788V22.7036Z' />
    <path d='M20.1176 22.7036H19.6006V23.2316H20.1176V22.7036Z' />
    <path d='M20.7836 22.7036H20.2656V23.2316H20.7836V22.7036Z' />
    <path d='M21.5229 22.7036H21.0049V23.2316H21.5229V22.7036Z' />
    <path d='M22.2616 22.7036H21.7446V23.2316H22.2616V22.7036Z' />
    <path d='M23.0019 22.7036H22.4839V23.2316H23.0019V22.7036Z' />
    <path d='M23.7407 22.7036H23.2227V23.2316H23.7407V22.7036Z' />
    <path d='M24.4809 22.7036H23.9629V23.2316H24.4809V22.7036Z' />
    <path d='M25.2196 22.7036H24.7017V23.2316H25.2196V22.7036Z' />
    <path d='M19.3788 23.4575H18.8608V23.9855H19.3788V23.4575Z' />
    <path d='M20.1176 23.4575H19.6006V23.9855H20.1176V23.4575Z' />
    <path d='M20.8578 23.4575H20.3398V23.9855H20.8578V23.4575Z' />
    <path d='M21.5229 23.4575H21.0049V23.9855H21.5229V23.4575Z' />
    <path d='M22.2616 23.4575H21.7446V23.9855H22.2616V23.4575Z' />
    <path d='M23.0019 23.4575H22.4839V23.9855H23.0019V23.4575Z' />
    <path d='M23.7407 23.4575H23.2227V23.9855H23.7407V23.4575Z' />
    <path d='M24.4809 23.4575H23.9629V23.9855H24.4809V23.4575Z' />
    <path d='M25.2196 23.4575H24.7017V23.9855H25.2196V23.4575Z' />
    <path d='M19.3788 24.1377H18.8608V24.6656H19.3788V24.1377Z' />
    <path d='M20.1176 24.1377H19.6006V24.6656H20.1176V24.1377Z' />
    <path d='M20.8578 24.1377H20.3398V24.6656H20.8578V24.1377Z' />
    <path d='M21.5229 24.1377H21.0049V24.6656H21.5229V24.1377Z' />
    <path d='M22.2616 24.1377H21.7446V24.6656H22.2616V24.1377Z' />
    <path d='M23.0019 24.1377H22.4839V24.6656H23.0019V24.1377Z' />
    <path d='M23.7407 24.1377H23.2227V24.6656H23.7407V24.1377Z' />
    <path d='M24.4809 24.1377H23.9629V24.6656H24.4809V24.1377Z' />
    <path d='M25.2196 24.1377H24.7017V24.6656H25.2196V24.1377Z' />
    <path d='M11.3938 25.2681L11.0938 25.4192H11.3938V25.2681Z' />
    <path d='M12.133 25.4203V25.0425L11.542 25.2692V25.4203H12.133Z' />
    <path d='M12.7987 25.4191C12.7912 25.241 12.7661 25.0642 12.7238 24.8911C12.5768 24.8911 12.4238 24.9667 12.2808 24.9667V25.3445H12.7987V25.4191Z' />
    <path d='M19.3788 24.8164H18.8608V25.3444H19.3788V24.8164Z' />
    <path d='M20.1176 24.8164H19.6006V25.3444H20.1176V24.8164Z' />
    <path d='M20.8578 24.8164H20.3398V25.3444H20.8578V24.8164Z' />
    <path d='M21.5229 24.8164H21.0049V25.3444H21.5229V24.8164Z' />
    <path d='M22.2616 24.8164H21.7446V25.3444H22.2616V24.8164Z' />
    <path d='M23.0019 24.8164H22.4839V25.3444H23.0019V24.8164Z' />
    <path d='M23.7407 24.8164H23.2227V25.3444H23.7407V24.8164Z' />
    <path d='M24.4809 24.8164H23.9629V25.3444H24.4809V24.8164Z' />
    <path d='M25.2196 24.8164H24.7017V25.3444H25.2196V24.8164Z' />
    <path d='M9.17485 26.0215L9.02686 26.096H9.17485V26.0215Z' />
    <path d='M9.91497 26.0982V25.7959L9.39697 25.947V26.0982H9.91497Z' />
    <path d='M10.6547 26.0983V25.5703L10.1367 25.7214V26.0993L10.6547 26.0983Z' />
    <path d='M11.394 25.5703H10.876V26.0983H11.394V25.5703Z' />
    <path d='M12.059 25.5703H11.542V26.0983H12.059V25.5703Z' />
    <path d='M12.7987 25.5703H12.2808V26.0983H12.7987V25.5703Z' />
    <path d='M13.095 26.0979C13.095 26.0223 13.095 26.0223 13.02 25.9468L13.095 26.0979Z' />
    <path d='M18.6399 25.7959C18.6511 25.9024 18.6245 26.0095 18.5649 26.0982H18.6399V25.7959Z' />
    <path d='M19.3788 25.5703H18.8608V26.0983H19.3788V25.5703Z' />
    <path d='M20.1176 25.5703H19.6006V26.0983H20.1176V25.5703Z' />
    <path d='M20.8578 25.5703H20.3398V26.0983H20.8578V25.5703Z' />
    <path d='M21.5229 25.5703H21.0049V26.0983H21.5229V25.5703Z' />
    <path d='M22.2616 25.5703H21.7446V26.0983H22.2616V25.5703Z' />
    <path d='M23.0019 25.5703H22.4839V26.0983H23.0019V25.5703Z' />
    <path d='M23.7407 25.5703H23.2227V26.0983H23.7407V25.5703Z' />
    <path d='M24.4809 25.5703H23.9629V26.0983H24.4809V25.5703Z' />
    <path d='M25.2196 25.5703H24.7017V26.0983H25.2196V25.5703Z' />
    <path d='M7.7707 26.7775V26.5508L7.17871 26.7019V26.7775H7.7707Z' />
    <path d='M8.43594 26.777V26.249L7.91895 26.4757V26.778L8.43594 26.777Z' />
    <path d='M9.1757 26.249H8.65771V26.777H9.1757V26.249Z' />
    <path d='M9.91497 26.249H9.39697V26.777H9.91497V26.249Z' />
    <path d='M10.6547 26.249H10.1367V26.777H10.6547V26.249Z' />
    <path d='M11.394 26.249H10.876V26.777H11.394V26.249Z' />
    <path d='M12.059 26.249H11.542V26.777H12.059V26.249Z' />
    <path d='M12.7987 26.249H12.2808V26.777H12.7987V26.249Z' />
    <path d='M13.02 26.777H13.391C13.316 26.6258 13.243 26.3991 13.169 26.249H13.021L13.02 26.777Z' />
    <path d='M18.639 26.249C18.565 26.4002 18.492 26.6268 18.418 26.777H18.639V26.249Z' />
    <path d='M19.3788 26.249H18.8608V26.777H19.3788V26.249Z' />
    <path d='M20.1176 26.249H19.6006V26.777H20.1176V26.249Z' />
    <path d='M20.8578 26.249H20.3398V26.777H20.8578V26.249Z' />
    <path d='M21.5229 26.249H21.0049V26.777H21.5229V26.249Z' />
    <path d='M22.2616 26.249H21.7446V26.777H22.2616V26.249Z' />
    <path d='M23.0019 26.249H22.4839V26.777H23.0019V26.249Z' />
    <path d='M23.7407 26.249H23.2227V26.777H23.7407V26.249Z' />
    <path d='M24.4809 26.249H23.9629V26.777H24.4809V26.249Z' />
    <path d='M24.7017 26.249V26.777H25.2196C25.2196 26.6258 25.2937 26.3991 25.2937 26.249H24.7017Z' />
    <path d='M7.02899 26.9273H6.66C6.65008 26.927 6.64019 26.9288 6.63096 26.9325C6.62174 26.9362 6.61337 26.9417 6.60635 26.9488C6.59933 26.9559 6.59382 26.9643 6.59015 26.9736C6.58647 26.9829 6.58471 26.9928 6.58499 27.0028C6.58499 27.154 6.66 27.3051 6.66 27.4552H7.10299L7.02899 26.9273Z' />
    <path d='M7.6967 26.9272H7.17871V27.4552H7.6967V26.9272Z' />
    <path d='M8.43594 26.9272H7.91895V27.4552H8.43594V26.9272Z' />
    <path d='M9.1757 26.9272H8.65771V27.4552H9.1757V26.9272Z' />
    <path d='M9.91497 26.9272H9.39697V27.4552H9.91497V26.9272Z' />
    <path d='M10.6547 26.9272H10.1367V27.4552H10.6547V26.9272Z' />
    <path d='M11.394 26.9272H10.876V27.4552H11.394V26.9272Z' />
    <path d='M12.059 26.9272H11.542V27.4552H12.059V26.9272Z' />
    <path d='M12.7987 26.9272H12.2808V27.4552H12.7987V26.9272Z' />
    <path d='M13.02 27.5308H13.538V27.0784C13.538 27.0028 13.464 27.0028 13.464 26.9272H13.02V27.5308Z' />
    <path d='M13.9068 27.531L13.7598 27.3799V27.531H13.9068Z' />
    <path d='M18.64 27.5309V27.0029H18.34C18.2683 27.1938 18.1671 27.372 18.04 27.5309H18.64Z' />
    <path d='M19.3788 26.9272H18.8608V27.4552H19.3788V26.9272Z' />
    <path d='M20.1176 26.9272H19.6006V27.4552H20.1176V26.9272Z' />
    <path d='M20.8578 26.9272H20.3398V27.4552H20.8578V26.9272Z' />
    <path d='M21.5229 26.9272H21.0049V27.4552H21.5229V26.9272Z' />
    <path d='M22.2616 26.9272H21.7446V27.4552H22.2616V26.9272Z' />
    <path d='M23.0019 26.9272H22.4839V27.4552H23.0019V26.9272Z' />
    <path d='M23.7407 26.9272H23.2227V27.4552H23.7407V26.9272Z' />
    <path d='M24.4809 26.9272H23.9629V27.4552H24.4809V26.9272Z' />
    <path d='M24.7017 27.5309H25.0706C25.1319 27.3621 25.1575 27.1823 25.1456 27.0029H24.7017V27.5309Z' />
    <path d='M7.03305 27.6812H6.66406C6.73806 27.8323 6.73805 28.059 6.81105 28.2091H7.11105L7.03305 27.6812Z' />
    <path d='M7.6967 27.6812H7.17871V28.2091H7.6967V27.6812Z' />
    <path d='M8.43594 27.6812H7.91895V28.2091H8.43594V27.6812Z' />
    <path d='M9.1757 27.6812H8.65771V28.2091H9.1757V27.6812Z' />
    <path d='M9.91497 27.6812H9.39697V28.2091H9.91497V27.6812Z' />
    <path d='M10.6547 27.6812H10.1367V28.2091H10.6547V27.6812Z' />
    <path d='M11.394 27.6812H10.876V28.2091H11.394V27.6812Z' />
    <path d='M12.059 27.6812H11.542V28.2091H12.059V27.6812Z' />
    <path d='M12.7987 27.6812H12.2808V28.2091H12.7987V27.6812Z' />
    <path d='M13.538 27.6812H13.02V28.2091H13.538V27.6812Z' />
    <path d='M13.7599 28.21H14.2769V27.8322L14.0558 27.6055H13.7559V28.21H13.7599Z' />
    <path d='M14.943 28.2101L14.499 27.9834V28.2101H14.943Z' />
    <path d='M17.8998 28.2111V27.6812C17.7462 27.8313 17.5721 27.9585 17.3828 28.059V28.2101L17.8998 28.2111Z' />
    <path d='M18.6401 27.6812H18.1221V28.2091H18.6401V27.6812Z' />
    <path d='M19.3788 27.6812H18.8608V28.2091H19.3788V27.6812Z' />
    <path d='M20.1176 27.6812H19.6006V28.2091H20.1176V27.6812Z' />
    <path d='M20.8578 27.6812H20.3398V28.2091H20.8578V27.6812Z' />
    <path d='M21.5229 27.6812H21.0049V28.2091H21.5229V27.6812Z' />
    <path d='M22.2616 27.6812H21.7446V28.2091H22.2616V27.6812Z' />
    <path d='M23.0019 27.6812H22.4839V28.2091H23.0019V27.6812Z' />
    <path d='M23.7407 27.6812H23.2227V28.2091H23.7407V27.6812Z' />
    <path d='M24.4809 27.6812H23.9629V28.2091H24.4809V27.6812Z' />
    <path d='M24.7017 28.2111H24.9237C24.9977 28.0599 24.9976 27.8332 25.0706 27.6831H24.7017V28.2111Z' />
    <path d='M7.03108 28.3599H6.80908C6.88308 28.511 6.88308 28.7377 6.95708 28.8878H7.03108V28.3599Z' />
    <path d='M7.6967 28.3599H7.17871V28.8878H7.6967V28.3599Z' />
    <path d='M8.43594 28.3599H7.91895V28.8878H8.43594V28.3599Z' />
    <path d='M9.1757 28.3599H8.65771V28.8878H9.1757V28.3599Z' />
    <path d='M9.91497 28.3599H9.39697V28.8878H9.91497V28.3599Z' />
    <path d='M10.6547 28.3599H10.1367V28.8878H10.6547V28.3599Z' />
    <path d='M11.394 28.3599H10.876V28.8878H11.394V28.3599Z' />
    <path d='M12.059 28.3599H11.542V28.8878H12.059V28.3599Z' />
    <path d='M12.7987 28.3599H12.2808V28.8878H12.7987V28.3599Z' />
    <path d='M13.538 28.3599H13.02V28.8878H13.538V28.3599Z' />
    <path d='M14.2768 28.3599H13.7598V28.8878H14.2768V28.3599Z' />
    <path d='M15.017 28.3599H14.499V28.8878H15.017V28.3599Z' />
    <path d='M15.2388 28.8893H15.7558V28.3613H15.2388V28.8893Z' />
    <path d='M16.4948 28.8893V28.3613H15.9028V28.8893H16.4948Z' />
    <path d='M17.1611 28.3599H16.6431V28.8878H17.1611V28.3599Z' />
    <path d='M17.8998 28.3599H17.3828V28.8878H17.8998V28.3599Z' />
    <path d='M18.6401 28.3599H18.1221V28.8878H18.6401V28.3599Z' />
    <path d='M19.3788 28.3599H18.8608V28.8878H19.3788V28.3599Z' />
    <path d='M20.1176 28.3599H19.6006V28.8878H20.1176V28.3599Z' />
    <path d='M20.8578 28.3599H20.3398V28.8878H20.8578V28.3599Z' />
    <path d='M21.5229 28.3599H21.0049V28.8878H21.5229V28.3599Z' />
    <path d='M22.2616 28.3599H21.7446V28.8878H22.2616V28.3599Z' />
    <path d='M23.0019 28.3599H22.4839V28.8878H23.0019V28.3599Z' />
    <path d='M23.7407 28.3599H23.2227V28.8878H23.7407V28.3599Z' />
    <path d='M24.4809 28.3599H23.9629V28.8878H24.4809V28.3599Z' />
    <path d='M24.7017 28.8893C24.7846 28.7247 24.8349 28.5453 24.8497 28.3613H24.7017V28.8893Z' />
    <path d='M7.6967 29.0391H7.17871V29.567H7.6967V29.0391Z' />
    <path d='M8.43594 29.0391H7.91895V29.567H8.43594V29.0391Z' />
    <path d='M9.1757 29.0391H8.65771V29.567H9.1757V29.0391Z' />
    <path d='M9.91497 29.0391H9.39697V29.567H9.91497V29.0391Z' />
    <path d='M10.6547 29.0391H10.1367V29.567H10.6547V29.0391Z' />
    <path d='M11.394 29.0391H10.876V29.567H11.394V29.0391Z' />
    <path d='M12.059 29.0391H11.542V29.567H12.059V29.0391Z' />
    <path d='M12.7987 29.0391H12.2808V29.567H12.7987V29.0391Z' />
    <path d='M13.538 29.0391H13.02V29.567H13.538V29.0391Z' />
    <path d='M14.2768 29.0391H13.7598V29.567H14.2768V29.0391Z' />
    <path d='M15.017 29.0391H14.499V29.567H15.017V29.0391Z' />
    <path d='M15.7558 29.0391H15.2388V29.567H15.7558V29.0391Z' />
    <path d='M16.4208 29.0391H15.9038V29.567H16.4208V29.0391Z' />
    <path d='M17.1611 29.0391H16.6431V29.567H17.1611V29.0391Z' />
    <path d='M17.8998 29.0391H17.3828V29.567H17.8998V29.0391Z' />
    <path d='M18.6401 29.0391H18.1221V29.567H18.6401V29.0391Z' />
    <path d='M19.3788 29.0391H18.8608V29.567H19.3788V29.0391Z' />
    <path d='M20.1176 29.0391H19.6006V29.567H20.1176V29.0391Z' />
    <path d='M20.8578 29.0391H20.3398V29.567H20.8578V29.0391Z' />
    <path d='M21.5229 29.0391H21.0049V29.567H21.5229V29.0391Z' />
    <path d='M22.2616 29.0391H21.7446V29.567H22.2616V29.0391Z' />
    <path d='M23.0019 29.0391H22.4839V29.567H23.0019V29.0391Z' />
    <path d='M23.7407 29.0391H23.2227V29.567H23.7407V29.0391Z' />
    <path d='M23.9629 29.0391V29.567H24.4059C24.4059 29.4915 24.4809 29.4159 24.4809 29.3403V29.0381L23.9629 29.0391Z' />
    <path d='M7.7709 29.7949H7.25391C7.32791 29.9461 7.4009 30.1727 7.4749 30.3229H7.7749L7.7709 29.7949Z' />
    <path d='M8.43594 29.7949H7.91895V30.3229H8.43594V29.7949Z' />
    <path d='M9.1757 29.7949H8.65771V30.3229H9.1757V29.7949Z' />
    <path d='M9.91497 29.7949H9.39697V30.3229H9.91497V29.7949Z' />
    <path d='M10.6547 29.7949H10.1367V30.3229H10.6547V29.7949Z' />
    <path d='M11.394 29.7949H10.876V30.3229H11.394V29.7949Z' />
    <path d='M12.059 29.7949H11.542V30.3229H12.059V29.7949Z' />
    <path d='M12.7987 29.7949H12.2808V30.3229H12.7987V29.7949Z' />
    <path d='M13.538 29.7949H13.02V30.3229H13.538V29.7949Z' />
    <path d='M14.2768 29.7949H13.7598V30.3229H14.2768V29.7949Z' />
    <path d='M15.017 29.7949H14.499V30.3229H15.017V29.7949Z' />
    <path d='M15.7558 29.7949H15.2388V30.3229H15.7558V29.7949Z' />
    <path d='M16.4208 29.7949H15.9038V30.3229H16.4208V29.7949Z' />
    <path d='M17.1611 29.7949H16.6431V30.3229H17.1611V29.7949Z' />
    <path d='M17.8998 29.7949H17.3828V30.3229H17.8998V29.7949Z' />
    <path d='M18.6401 29.7949H18.1221V30.3229H18.6401V29.7949Z' />
    <path d='M19.3788 29.7949H18.8608V30.3229H19.3788V29.7949Z' />
    <path d='M20.1176 29.7949H19.6006V30.3229H20.1176V29.7949Z' />
    <path d='M20.8578 29.7949H20.3398V30.3229H20.8578V29.7949Z' />
    <path d='M21.5229 29.7949H21.0049V30.3229H21.5229V29.7949Z' />
    <path d='M22.2616 29.7949H21.7446V30.3229H22.2616V29.7949Z' />
    <path d='M23.0019 29.7949H22.4839V30.3229H23.0019V29.7949Z' />
    <path d='M23.7407 29.7949H23.2227V30.3229H23.7407V29.7949Z' />
    <path d='M23.9629 30.3229C24.1099 30.1652 24.2341 29.9875 24.3319 29.7949H23.9629V30.3229Z' />
    <path d='M7.54883 30.4727C7.62283 30.6238 7.69584 30.6994 7.76983 30.8505V30.4727H7.54883Z' />
    <path d='M8.43594 30.4727H7.91895V31.0006H8.43594V30.4727Z' />
    <path d='M9.1757 30.4727H8.65771V31.0006H9.1757V30.4727Z' />
    <path d='M9.91497 30.4727H9.39697V31.0006H9.91497V30.4727Z' />
    <path d='M10.6547 30.4727H10.1367V31.0006H10.6547V30.4727Z' />
    <path d='M11.394 30.4727H10.876V31.0006H11.394V30.4727Z' />
    <path d='M12.059 30.4727H11.542V31.0006H12.059V30.4727Z' />
    <path d='M12.7987 30.4727H12.2808V31.0006H12.7987V30.4727Z' />
    <path d='M13.538 30.4727H13.02V31.0006H13.538V30.4727Z' />
    <path d='M14.2768 30.4727H13.7598V31.0006H14.2768V30.4727Z' />
    <path d='M15.017 30.4727H14.499V31.0006H15.017V30.4727Z' />
    <path d='M15.7558 30.4727H15.2388V31.0006H15.7558V30.4727Z' />
    <path d='M16.4208 30.4727H15.9038V31.0006H16.4208V30.4727Z' />
    <path d='M17.1611 30.4727H16.6431V31.0006H17.1611V30.4727Z' />
    <path d='M17.8998 30.4727H17.3828V31.0006H17.8998V30.4727Z' />
    <path d='M18.6401 30.4727H18.1221V31.0006H18.6401V30.4727Z' />
    <path d='M19.3788 30.4727H18.8608V31.0006H19.3788V30.4727Z' />
    <path d='M20.1176 30.4727H19.6006V31.0006H20.1176V30.4727Z' />
    <path d='M20.8578 30.4727H20.3398V31.0006H20.8578V30.4727Z' />
    <path d='M21.5229 30.4727H21.0049V31.0006H21.5229V30.4727Z' />
    <path d='M22.2616 30.4727H21.7446V31.0006H22.2616V30.4727Z' />
    <path d='M23.0019 30.4727H22.4839V31.0006H23.0019V30.4727Z' />
    <path d='M23.2227 30.4727V31.0006H23.6667C23.7407 30.9251 23.7407 30.8495 23.8137 30.8495V30.4717L23.2227 30.4727Z' />
    <path d='M8.43594 31.1519H7.91895C8.06594 31.303 8.13993 31.5297 8.28793 31.6798H8.43493L8.43594 31.1519Z' />
    <path d='M9.1757 31.1519H8.65771V31.6828H9.1757V31.1519Z' />
    <path d='M9.91497 31.1519H9.39697V31.6828H9.91497V31.1519Z' />
    <path d='M10.6547 31.1519H10.1367V31.6828H10.6547V31.1519Z' />
    <path d='M11.394 31.1519H10.876V31.6828H11.394V31.1519Z' />
    <path d='M12.059 31.1519H11.542V31.6828H12.059V31.1519Z' />
    <path d='M12.7987 31.1519H12.2808V31.6828H12.7987V31.1519Z' />
    <path d='M13.538 31.1519H13.02V31.6828H13.538V31.1519Z' />
    <path d='M14.2768 31.1519H13.7598V31.6828H14.2768V31.1519Z' />
    <path d='M15.017 31.1519H14.499V31.6828H15.017V31.1519Z' />
    <path d='M15.7558 31.1519H15.2388V31.6828H15.7558V31.1519Z' />
    <path d='M16.4208 31.1519H15.9038V31.6828H16.4208V31.1519Z' />
    <path d='M17.1611 31.1519H16.6431V31.6828H17.1611V31.1519Z' />
    <path d='M17.8998 31.1519H17.3828V31.6828H17.8998V31.1519Z' />
    <path d='M18.6401 31.1519H18.1221V31.6828H18.6401V31.1519Z' />
    <path d='M19.3788 31.1519H18.8608V31.6828H19.3788V31.1519Z' />
    <path d='M20.1176 31.1519H19.6006V31.6828H20.1176V31.1519Z' />
    <path d='M20.8578 31.1519H20.3398V31.6828H20.8578V31.1519Z' />
    <path d='M21.5229 31.1519H21.0049V31.6828H21.5229V31.1519Z' />
    <path d='M22.2616 31.1519H21.7446V31.6828H22.2616V31.1519Z' />
    <path d='M23.0019 31.1519H22.4839V31.6828H23.0019V31.1519Z' />
    <path d='M23.2227 31.6044C23.3039 31.4645 23.405 31.3372 23.5227 31.2266H23.2227V31.6044Z' />
    <path d='M9.1757 31.8311H8.65771V32.1333L8.87971 32.36H9.17971L9.1757 31.8311Z' />
    <path d='M9.91497 31.8311H9.39697V32.359H9.91497V31.8311Z' />
    <path d='M10.6547 31.8311H10.1367V32.359H10.6547V31.8311Z' />
    <path d='M11.394 31.8311H10.876V32.359H11.394V31.8311Z' />
    <path d='M12.059 31.8311H11.542V32.359H12.059V31.8311Z' />
    <path d='M12.7987 31.8311H12.2808V32.359H12.7987V31.8311Z' />
    <path d='M13.538 31.8311H13.02V32.359H13.538V31.8311Z' />
    <path d='M14.2768 31.8311H13.7598V32.359H14.2768V31.8311Z' />
    <path d='M15.017 31.8311H14.499V32.359H15.017V31.8311Z' />
    <path d='M15.7558 31.8311H15.2388V32.359H15.7558V31.8311Z' />
    <path d='M16.4208 31.8311H15.9038V32.359H16.4208V31.8311Z' />
    <path d='M17.1611 31.8311H16.6431V32.359H17.1611V31.8311Z' />
    <path d='M17.8998 31.8311H17.3828V32.359H17.8998V31.8311Z' />
    <path d='M18.6401 31.8311H18.1221V32.359H18.6401V31.8311Z' />
    <path d='M19.3788 31.8311H18.8608V32.359H19.3788V31.8311Z' />
    <path d='M20.1176 31.8311H19.6006V32.359H20.1176V31.8311Z' />
    <path d='M20.8578 31.8311H20.3398V32.359H20.8578V31.8311Z' />
    <path d='M21.5229 31.8311H21.0049V32.359H21.5229V31.8311Z' />
    <path d='M22.2616 31.8311H21.7446V32.359H22.2616V31.8311Z' />
    <path d='M22.4839 32.359L23.0019 31.8311H22.4839V32.359Z' />
    <path d='M9.02686 32.5845L9.17485 32.7356V32.5845H9.02686Z' />
    <path d='M9.91497 32.5845H9.39697V32.9633L9.61897 33.19H9.91897L9.91497 32.5845Z' />
    <path d='M10.6547 32.5845H10.1367V33.1124H10.6547V32.5845Z' />
    <path d='M11.394 32.5845H10.876V33.1124H11.394V32.5845Z' />
    <path d='M12.059 32.5845H11.542V33.1124H12.059V32.5845Z' />
    <path d='M12.7987 32.5845H12.2808V33.1124H12.7987V32.5845Z' />
    <path d='M13.538 32.5845H13.02V33.1124H13.538V32.5845Z' />
    <path d='M14.2768 32.5845H13.7598V33.1124H14.2768V32.5845Z' />
    <path d='M15.017 32.5845H14.499V33.1124H15.017V32.5845Z' />
    <path d='M15.7558 32.5845H15.2388V33.1124H15.7558V32.5845Z' />
    <path d='M16.4208 32.5845H15.9038V33.1124H16.4208V32.5845Z' />
    <path d='M17.1611 32.5845H16.6431V33.1124H17.1611V32.5845Z' />
    <path d='M17.8998 32.5845H17.3828V33.1124H17.8998V32.5845Z' />
    <path d='M18.6401 32.5845H18.1221V33.1124H18.6401V32.5845Z' />
    <path d='M19.3788 32.5845H18.8608V33.1124H19.3788V32.5845Z' />
    <path d='M20.1176 32.5845H19.6006V33.1124H20.1176V32.5845Z' />
    <path d='M20.8578 32.5845H20.3398V33.1124H20.8578V32.5845Z' />
    <path d='M21.5229 32.5845H21.0049V33.1124H21.5229V32.5845Z' />
    <path d='M21.7446 33.0369C21.9324 32.905 22.1057 32.7533 22.2616 32.5845H21.7446V33.0369Z' />
    <path d='M9.84082 33.2637L9.91382 33.3372V33.2637H9.84082Z' />
    <path d='M10.1367 33.2637V33.4904C10.2919 33.6188 10.4669 33.7209 10.6547 33.7926V33.2647L10.1367 33.2637Z' />
    <path d='M11.394 33.2637H10.876V33.7916H11.394V33.2637Z' />
    <path d='M12.059 33.2637H11.542V33.7916H12.059V33.2637Z' />
    <path d='M12.7987 33.2637H12.2808V33.7916H12.7987V33.2637Z' />
    <path d='M13.538 33.2637H13.02V33.7916H13.538V33.2637Z' />
    <path d='M14.2768 33.2637H13.7598V33.7916H14.2768V33.2637Z' />
    <path d='M15.017 33.2637H14.499V33.7916H15.017V33.2637Z' />
    <path d='M15.7558 33.2637H15.2388V33.7916H15.7558V33.2637Z' />
    <path d='M16.4208 33.2637H15.9038V33.7916H16.4208V33.2637Z' />
    <path d='M17.1611 33.2637H16.6431V33.7916H17.1611V33.2637Z' />
    <path d='M17.8998 33.2637H17.3828V33.7916H17.8998V33.2637Z' />
    <path d='M18.6401 33.2637H18.1221V33.7916H18.6401V33.2637Z' />
    <path d='M19.3788 33.2637H18.8608V33.7916H19.3788V33.2637Z' />
    <path d='M20.1176 33.2637H19.6006V33.7916H20.1176V33.2637Z' />
    <path d='M20.3398 33.2637V33.7917H20.5618C20.7088 33.7161 20.7838 33.6405 20.9308 33.6405V33.2627L20.3398 33.2637Z' />
    <path d='M21.0049 33.4904C21.1529 33.4148 21.2269 33.3392 21.3739 33.2637H21.0049V33.4904Z' />
    <path d='M10.9478 33.9375L11.3907 34.1642V33.9375H10.9478Z' />
    <path d='M11.542 33.9375V34.2398C11.689 34.3153 11.912 34.3909 12.059 34.4665V34.0141L11.542 33.9375Z' />
    <path d='M12.7987 33.9375H12.2808V34.4654H12.7987V33.9375Z' />
    <path d='M13.538 33.9375H13.02V34.4654H13.538V33.9375Z' />
    <path d='M14.2768 33.9375H13.7598V34.4654H14.2768V33.9375Z' />
    <path d='M15.017 33.9375H14.499V34.4654H15.017V33.9375Z' />
    <path d='M15.7558 33.9375H15.2388V34.4654H15.7558V33.9375Z' />
    <path d='M16.4208 33.9375H15.9038V34.4654H16.4208V33.9375Z' />
    <path d='M17.1611 33.9375H16.6431V34.4654H17.1611V33.9375Z' />
    <path d='M17.8998 33.9375H17.3828V34.4654H17.8998V33.9375Z' />
    <path d='M18.6401 33.9375H18.1221V34.4654H18.6401V33.9375Z' />
    <path d='M18.8608 33.9375V34.4654C19.0218 34.3808 19.1979 34.3295 19.3788 34.3143V34.0121L18.8608 33.9375Z' />
    <path d='M19.6006 33.9375V34.1642C19.7476 34.0886 19.9696 34.0131 20.1176 33.9375H19.6006Z' />
    <path d='M13.02 34.6973C13.168 34.7728 13.391 34.7728 13.538 34.8484V34.6973H13.02Z' />
    <path d='M13.7598 34.6973V34.8484C13.9068 34.8484 14.1288 34.924 14.2768 34.924V34.6973H13.7598Z' />
    <path d='M14.499 34.6973V34.924H15.017V34.6973H14.499Z' />
    <path d='M15.2388 34.6973V34.9995H15.7558V34.6973H15.2388Z' />
    <path d='M15.9038 34.6973V34.924H16.4208V34.6973H15.9038Z' />
    <path d='M16.6431 34.6973V34.924C16.8191 34.936 16.9957 34.9103 17.1611 34.8484V34.6973H16.6431Z' />
    <path d='M17.3828 34.6973V34.8484C17.5298 34.8484 17.7518 34.7728 17.8998 34.7728H17.3828V34.6973Z' />
  </svg>
);

export default Logo;
